import { render, staticRenderFns } from "./simLogins.vue?vue&type=template&id=8654cc8a&scoped=true&"
import script from "./simLogins.vue?vue&type=script&lang=js&"
export * from "./simLogins.vue?vue&type=script&lang=js&"
import style0 from "./simLogins.vue?vue&type=style&index=0&id=8654cc8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8654cc8a",
  null
  
)

export default component.exports